import { diff } from "@otto-ec/assets-core-utils/array-web";
import type { NavigationScopeOptions, NavigationScopeState } from "./scope.types.js";
import { defaultEntryComparator, NAV_META, NAV_SCOPES } from "../lib/utils.js";
import { current, onNavigate } from "../lib/navigation.client.js";
import type { NavigationCurrent } from "../lib/navigation.types.js";
import {
  hashFiltered,
  pathFiltered,
  scopesFiltered,
  searchFiltered,
  type AnyNavigationScope,
} from "./cache.js";

/**
 *
 *
 *
 *
 *
 *
 *
 */
export const cloneNavigationStateForDispatch = (
  to: NavigationCurrent,
  forScope: AnyNavigationScope,
): NavigationScopeState<NavigationScopeOptions> => {
  /*                                                */
  return {
    /*                                                                       */
    /*                                                                       */
    hash: forScope.hash().fromEntries(to.hash.toEntries()).clone(),
    search: forScope.search().fromEntries(to.search.toEntries()).clone(),
    /*                                                      */
    state: forScope.state(to.state[NAV_SCOPES][forScope.name] ?? {}).clone(),
    /*                    */
    url: new URL(to.url),
    /*                                     */
    info: to.info,
    type: to.type,
  };
};

/**
 *
 */
export const diffEntries = <T extends [string, unknown]>(a: T[], b: T[]): T[] =>
  diff(a, b, defaultEntryComparator)[2];

/**
 *
 *
 *
 *
 *
 */
export const findScopeTargetsToNotify = (
  to: NavigationCurrent,
  from: NavigationCurrent,
): [
  hashTargets: Set<AnyNavigationScope>,
  searchTargets: Set<AnyNavigationScope>,
  scopeTargets: Set<AnyNavigationScope>,
  allTargets: Set<AnyNavigationScope>,
] => {
  const hashTargets = new Set<AnyNavigationScope>();
  const searchTargets = new Set<AnyNavigationScope>();
  const scopeTargets = new Set<AnyNavigationScope>();
  const pathTargets = new Set<AnyNavigationScope>();

  /*                                                          */
  diffEntries(to.hash.toEntries(), from.hash.toEntries()).forEach(([key]) =>
    hashFiltered.get(key)?.forEach((t) => hashTargets.add(t)),
  );

  /*                                                            */
  diffEntries(to.search.toEntries(), from.search.toEntries()).forEach(([key]) =>
    searchFiltered.get(key)?.forEach((t) => searchTargets.add(t)),
  );

  /*                                                   */
  diffEntries(Object.entries(to.state[NAV_META]), Object.entries(from.state[NAV_META])).forEach(
    ([key]) => scopesFiltered.get(key)?.forEach((t) => scopeTargets.add(t)),
  );

  /*                                                */
  pathFiltered.forEach((set, pattern) => {
    const { pathname: toPath } = to.url;
    const { pathname: fromPath } = from.url;
    /*                                                   */
    if (toPath === fromPath) return;
    /*                                                             */
    if ([toPath, fromPath].some((p) => pattern.test(p))) {
      set.forEach((t) => pathTargets.add(t));
    }
  });

  /*                                                                                         */
  /*                                  */
  const allTargets = new Set([...hashTargets, ...searchTargets, ...scopeTargets, ...pathTargets]);

  return [hashTargets, searchTargets, scopeTargets, allTargets] as const;
};

/**
 *
 *
 *
 *
 */
export function initScopes(): void {
  onNavigate.subscribe((cur) => {
    findScopeTargetsToNotify(cur.destination, cur.from)[3].forEach((t) =>
      t.onNavigate.dispatch({
        cancel: cur.cancel,
        onComplete: cur.onComplete,
        info: cur.info,
        type: cur.type,
        from: cur.from,
        destination: cur.destination,
        to: cloneNavigationStateForDispatch(cur.destination, t),
        cancelable: cur.cancelable,
      }),
    );
  });

  current.subscribe(
    (cur, old) => {
      const targets = findScopeTargetsToNotify(cur, old!);
      /*                                        */
      targets[3].forEach((t) => t.current.set(cloneNavigationStateForDispatch(cur, t)));
      /*                                                */
      /*                                                                            */
      targets[0].forEach((t) => t.currentHash.set(t.current.get().hash));
      targets[1].forEach((t) => t.currentSearch.set(t.current.get().search));
      targets[2].forEach((t) => t.currentState.set(t.current.get().state));
    },
    { skipRetained: true },
  );
}
